import { client } from "../../infrastructure/graphql/client";
import {
  GET_MONTHLY_COSTS_BY_DATE_RANGE,
  GET_TOTAL_COST_FOR_VMS,
  GET_VM_COST_DETAIL,
  GET_VM_COST_HISTORY,
  GET_VM_COST_HISTORY_BY_DATE_RANGE,
  GET_VM_COSTS_BY_MONTH_AND_YEAR,
  GET_VM_COSTS_BY_SERVICE_FOR_VM,
} from "../../infrastructure/graphql/vmCostQueries";

export class VmCostService {
  async getVmCostHistory(index = 0) {
    try {
      const result = await client.query({
        query: GET_VM_COST_HISTORY,
        variables: { index },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getVmCostHistory;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM cost history error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }
  async getVmCostsByMonthAndYear(year, month) {
    try {
      const result = await client.query({
        query: GET_VM_COSTS_BY_MONTH_AND_YEAR,
        variables: { year, month },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getVmCostsByMonthAndYear;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM costs by month/year error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async getVmCostDetail(vmId, year, month) {
    try {
      const result = await client.query({
        query: GET_VM_COST_DETAIL,
        variables: { vmId, year, month },
        fetchPolicy: "network-only",
      });
      const response = result.data?.getVmCostDetail;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, data: response };
    } catch (error) {
      console.error("Get VM cost detail error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async getVmCostsByServiceForVm(vmId, year, month) {
    try {
      const result = await client.query({
        query: GET_VM_COSTS_BY_SERVICE_FOR_VM,
        variables: { vmId, year, month },
        fetchPolicy: "network-only",
      });
      const response = result.data?.getVmCostsByServiceForVm;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, data: response };
    } catch (error) {
      console.error("Get VM costs by service error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async getVmCostHistoryByDateRange(vmId, startDate, endDate) {
    try {
      const result = await client.query({
        query: GET_VM_COST_HISTORY_BY_DATE_RANGE,
        variables: { vmId, startDate, endDate },
        fetchPolicy: "network-only",
      });
      const response = result.data?.getVmCostHistoryByDateRange;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, data: response };
    } catch (error) {
      console.error("Get VM cost history error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
  async getMonthlyCostsByDateRange(vmId, startDate, endDate) {
    try {
      const result = await client.query({
        query: GET_MONTHLY_COSTS_BY_DATE_RANGE,
        variables: { vmId, startDate, endDate },
        fetchPolicy: "network-only",
      });
      const response = result.data?.getMonthlyCostsByDateRange;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, data: response };
    } catch (error) {
      console.error("Get monthly costs by date range error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
  async getTotalCostForVms(vmIds, startMonth, startYear, endMonth, endYear) {
    try {
      const result = await client.query({
        query: GET_TOTAL_COST_FOR_VMS,
        variables: { vmIds, startMonth, startYear, endMonth, endYear },
        fetchPolicy: "network-only",
      });
      const response = result.data?.getTotalCostForVms;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, data: response };
    } catch (error) {
      console.error("Get total cost for VMs error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
}
